import WorkspaceAPI from '../WorkspaceAPI';
import _ from 'lodash';

type IFun = typeof WorkspaceAPI.useGetMyWorkspacesQuery;
function useWorkspaceById(
  id: string,
  arg1?: Parameters<IFun>[0],
  arg2?: Parameters<IFun>[1]
) {
  return WorkspaceAPI.useGetMyWorkspacesQuery(arg1, {
    ...arg2,
    selectFromResult: (response) => ({
      ...response,
      data: _.find(response.data, (workspace) => workspace.id === id),
    }),
  });
}

export default useWorkspaceById;
